<template lang="pug">
  .quote-viewer
    .header
      p Quote #:
        span.right(v-if="quote.state == 'quoted' || quote.state == 'accepted'" @click="viewFullQuote(quote)") 
          svg(xmlns="http://www.w3.org/2000/svg" width="16.133" height="20" viewBox="0 0 16.133 20")
            path(d="M7.833,26.956h8.578a.58.58,0,0,0,0-1.156H7.833a.551.551,0,0,0-.533.578A.526.526,0,0,0,7.833,26.956Z" transform="translate(-4.056 -14.333)" fill="#fff")
            path(d="M7.833,18.056h3.689a.58.58,0,0,0,0-1.156H7.833a.58.58,0,0,0,0,1.156Z" transform="translate(-4.056 -9.389)" fill="#fff")
            path(d="M7.833,35.956h8.578a.58.58,0,0,0,0-1.156H7.833a.58.58,0,0,0,0,1.156Z" transform="translate(-4.056 -19.333)" fill="#fff")
            path(d="M15.6,4.622,11.467.489A1.282,1.282,0,0,0,10.489,0H1.556A1.575,1.575,0,0,0,0,1.556V18.444A1.575,1.575,0,0,0,1.556,20H14.578a1.546,1.546,0,0,0,1.556-1.556V5.867A1.635,1.635,0,0,0,15.6,4.622Zm-.711,13.733a.4.4,0,0,1-.4.4H1.644a.4.4,0,0,1-.4-.4V1.644a.4.4,0,0,1,.4-.4h8.489v3.2A1.575,1.575,0,0,0,11.689,6h3.2Z" fill="#fff")
          | View Full Page
      p.quote {{quote.id}}
        span.tag(v-if="quote.state == 'requested'") Requested
        span.tag.accepted(v-if="quote.state == 'accepted'") Accepted
        span.right(v-if="quote.state == 'quoted' || quote.state == 'accepted'")
          a.download(v-if="downloadLink" :href="downloadLink" target="_blank")
            svg(xmlns="http://www.w3.org/2000/svg" width="17.86" height="17.959" viewBox="0 0 17.86 17.959")
              g(transform="translate(-307.12 -193.25)")
                path(d="M987.052,1356.906l5.155,5.155,5.155-5.155" transform="translate(-676.114 -1155.856)" fill="none" stroke-linecap="round" stroke-width="1.5")
                path(d="M995.758,1345v12.021" transform="translate(-679.665 -1151)" fill="none" stroke-linecap="round" stroke-width="1.5")
            | Download
          span.download(v-else)
            svg(aria-hidden="true" width="16" height="16" viewBox="0 0 512 512" focusable="false" class="fa-spin")
              path(d="M370.7 133.3c-31.3-29.3-71.8-45.3-114.9-45.3-77.5 0.1-144.3 53.2-162.8 126.8-1.3 5.4-6.1 9.2-11.7 9.2h-57.3c-7.5 0-13.2-6.8-11.8-14.2 21.6-114.9 122.5-201.8 243.7-201.8 66.4 0 126.8 26.1 171.3 68.7l35.7-35.7c15.1-15.1 41-4.4 41 17v134.1c0 13.3-10.7 24-24 24h-134.1c-21.4 0-32.1-25.9-17-41zM32 296h134.1c21.4 0 32.1 25.9 17 41l-41.8 41.8c31.3 29.3 71.8 45.3 114.9 45.3 77.4-0.1 144.3-53.1 162.8-126.8 1.3-5.4 6.1-9.2 11.7-9.2h57.3c7.5 0 13.2 6.8 11.8 14.2-21.6 114.9-122.5 201.8-243.7 201.8-66.4 0-126.8-26.1-171.3-68.7l-35.7 35.7c-15.1 15.1-41 4.4-41-17v-134.1c0-13.3 10.7-24 24-24z")
    .quote-info
      .address(v-if="accountInfo")
        h5.bold Delivery Address:
        p {{accountInfo.business}}
        p {{accountInfo.street}}
        p {{accountInfo.city}}, {{ accountInfo.state}} {{ accountInfo.postalCode }}
        br 
        p Attn: {{accountInfo.name}}
        p Phone: {{accountInfo.phoneNumber}}
        br
        p(v-if="quote.hasDock") Yes, I have a loading dock
        p(v-else) No loading dock available
      hr
      .date
        h5.bold Requested Delivery Time Frame:
        p {{formatDate(quote.deliveryTimeframe)}}
      hr
      .product-view
        h5.bold Products:
          span.right {{ quote.state == 'quoted' ||quote.state == 'accepted' ? "Price" : 'Qty'}}:
        .product(v-for='item in quote.items' :class="quote.state == 'quoted' || quote.state == 'accepted' ? 'quoted' : ''")
          .image
            a.thumb-wrapper(:href="item.product.fullLink")
              img(:src="item.product.image")
          .description
            a(:href="item.product.link" target="_blank")
              h5.product-title {{ item.product.title }} {{ quote.state == 'quoted' || quote.state == 'accepted' ? "x" + item.quantity : ''}}
            p.product-variations {{ item.notes }}
          .quantity(v-if="quote.state == 'requested'")
            p.bold {{item.quantity}}
          .price(v-if="quote.state == 'quoted' ||quote.state == 'accepted'")
            p.bold {{ formatPrice(getLinePrice(item)) }}
        hr
      .total-quantity(v-if="quote.state == 'requested'")
        h5.total.bold Total Qty:
          span.right {{totalQuantity}}
      .total-price(v-if="quote.state == 'quoted' ||quote.state == 'accepted'")
        p.total(v-if="quote.surchargePrice") Surcharge/Tariff Fee (2%):
          span.right {{formatPrice(quote.surchargePrice)}}
        p.total Shipping Cost:
          span.right {{formatPrice(quote.freight)}}        
        p.total(v-if="quote.liftGateCharge") Liftgate Charge:
          span.right {{formatPrice(quote.liftGateCharge)}}
        p.total Tax ({{quote.taxRate}}%):
          span.right {{formatPrice(quote.tax)}}
        hr
        h4.grand-total.total.bold TOTAL:
          span.right {{formatPrice(quote.total)}}
      h5.bold Notes for Sales Rep:
      textarea.notes(v-model="quote.notes" disabled placeholder="No Notes")
      button(v-if="quote.state == 'quoted'" @click="viewFullQuote(quote)") Accept Quote
      p.decline(v-if="quote.state == 'quoted'")
        a(@click="declineQuote(quote)") Decline
      
    financing(v-if="this.$root.currentSite == 'MityLite'")
</template>

<script>
import connect from "../scripts/database.js";
import Accounts from "../scripts/accounts.js";
import Axios from "axios";
import { Quotes } from "../scripts/quotes.js";
import Activity from "../scripts/activity.js";

export default {
  name: "QuoteViewer",
  props: ["quote"],
  data() {
    return {
      accountInfo: null,
      downloadLink: "",
      retry: 0
    };
  },
  computed: {
    totalQuantity: function() {
      var total = 0;
      for (var i = 0; i < this.quote.items.length; i++) {
        total = total + parseInt(this.quote.items[i].quantity);
      }
      return total;
    }
  },
  watch: {},
  methods: {
    getLinePrice(item) {
      var amt = parseFloat(item.product.unitPrice) * parseInt(item.quantity);
      return isNaN(amt) ? 0 : parseFloat(amt.toFixed(2));
    },
    formatPrice(value) {
      if (value) {
        return (
          "$" +
          parseFloat(value)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
        );
      } else {
        return "0.00";
      }
    },
    checkDownloadLink() {
      let fileName =
        this.$root.currentUser.uid +
        "/" +
        this.quote.id +
        "-v" +
        this.quote.version +
        ".pdf";

      connect.storage
        .ref("invoices")
        .child(fileName)
        .getDownloadURL()
        .then(url => {
          this.downloadLink = url;
        })
        .catch(error => {
          return Axios.post(
            `${process.env.VUE_APP_FIREBASE.cloudFunctionURL}/requestPDF`,
            {
              quoteId: this.quote.id,
              userId: this.$root.currentUser.uid
            }
          )
            .then(() => {
              //retry
              if (this.retry <= 3) {
                this.checkDownloadLink();
                this.retry++;
              }
            })
            .catch(() => {
              console.log("invoice file not found");
            });
        });
    },
    viewFullQuote(quote) {
      this.$root.fullView = true;
    },
    declineQuote(quote) {
      this.quote.step = 1;
      this.quote.state = "draft";
      Quotes.saveQuote(this.quote);
      this.$root.activeDraft = this.quote;
      this.$root.currentPage = "Quotes";
      this.$root.currentState = "draft";
    }
  },
  mounted: function() {
    if (this.quote.state == "quoted" || this.quote.state == "accepted") {
      this.checkDownloadLink();
    }

    Activity.userActivity(this.$root.currentUser, "quote:view", {
      quote: this.quote
    });
  },
  created: function() {
    Accounts.getAccount(this.$root.currentUser.uid).then(results => {
      this.accountInfo = results;
      this.accountInfo.uid = this.$root.currentUser.uid;
    });
  }
};
</script>

<style lang="scss">
@import "../assets/styles/reset.scss";
@import "../assets/styles/variables.scss";

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}

#app .quote-viewer {
  hr {
    margin: 1em 0;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: solid 2px $border_gray;
    width: 100%;
  }
  .bold {
    font-weight: 500;
  }
  p {
    font-size: 0.875em;
    color: #000;
  }
  .header {
    padding: 24px;
    background: $light_gray;
    p {
      color: $text_color;
    }
    span.right {
      color: $link_color;
      text-decoration: underline;
      line-height: normal;
      svg {
        height: 15px;
        margin-right: 2px;
        fill: $link_color;
        vertical-align: bottom;
        path {
          stroke: $link_color;
        }
      }
    }
    span.right:hover {
      color: $link_hover;
      text-decoration: underline;
      cursor: pointer;

      svg path {
        stroke: $link_hover;
      }
    }
    p.quote {
      font-size: 1.2em;
      font-weight: 500;
      padding: 0.5em 0 0;
      color: $text_color;
      span.tag {
        background-color: $alert_green;
        color: #fff;
        font-weight: 300;
        font-size: 0.6em;
        padding: 2px 6px 2px 4px;
        font-style: italic;
        vertical-align: middle;
        margin-left: 5px;
      }
      span.accepted {
        background-color: $alert_green;
      }
      svg {
        width: 15px;
        margin-right: 2px;
        fill: $link_color;
        vertical-align: middle;
        path {
          stroke: $link_color;
        }
      }
      svg:hover {
        cursor: pointer;
        fill: $link_hover;
      }
      a.download {
        font-size: 14px;
        vertical-align: middle;
        font-weight: 400;

        svg path {
          stroke: $link_color;
        }

        &:hover svg path {
          stroke: $link_hover;
        }
      }
    }
  }
  .quote-info {
    padding: 24px;
  }
  h5 {
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 1em;
    color: $text_color;
  }
  .date {
    h5 {
      margin-bottom: 5px;
      color: $text_color;
    }
  }
  .product-view {
    h5 {
      margin-right: 1em;
      color: $text_color;
    }
    .head {
      margin-bottom: 1em;
      margin-right: 1em;
    }
    .product {
      display: flex;
      flex-wrap: wrap;
      margin-right: 1em;
      margin-bottom: 1em;
      .image {
        width: 20%;
        border-radius: 10px;
        line-height: 0;
        img {
          width: 100%;
        }
      }
      &.quoted .description {
        width: 60%;
      }
      .description {
        width: 75%;
        padding: 0 5px 0 10px;
        .product-title {
          color: $link_color;
          font-weight: 500;
          margin-bottom: 5px;
          font-size: 0.9em !important;
        }
        .product-title:hover {
          color: $link_hover;
        }
        .product-variations {
          font-size: 0.8em;
        }
      }
      .quantity {
        width: 5%;
        display: block;
        text-align: right;
        font-size: 0.9em;
      }
      .price {
        width: 20%;
        text-align: right;
        font-size: 0.9em;
        color: $text_color;
        p {
          color: $text_color;
        }
      }
    }
  }
  span.right {
    float: right;
  }
  .total {
    margin-right: 1em;
    margin-bottom: 1em;
  }
  .grand-total {
    color: $text_color;
  }
  .notes {
    width: 100%;
    padding: 1em;
    height: 150px;
    border-radius: 8px;
    resize: none;
    background-color: transparent;
  }
  p.decline {
    text-align: center;
    text-decoration: underline;
  }
}
</style>
